import { Box, useTheme } from '@mui/material';

import { SupervisorQueueContent } from './components/SupervisorQueueContent';
import { SupervisorQueueHeader } from './components/SupervisorQueueHeader';

export const SupervisorQueue = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        pl: theme.spacing(6),
        pr: theme.spacing(6),
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(4),
      }}
    >
      <SupervisorQueueHeader />
      <SupervisorQueueContent />
    </Box>
  );
};
